// Common event names for the brand logged out homepage
export const EVENT_NAMES = {
    // Mixpanel events
    MIXPANEL: {
        CLICKED_POPULAR_SEARCH_TAG: 'Clicked popular search tag',
        LOHP_CLICKED_CATALOG_SERVICE_BUTTON: 'LOHP - Clicked Catalog Service Button',
        LOHP_CLICKED_CATALOG_CTA: 'LOHP - Clicked Catalog CTA',
        LOHP_CLICKED_CATALOG_SERVICE_CARD_SELLER: 'LOHP - Clicked Catalog Service Card - Seller',
        LOHP_CLICKED_CATALOG_SERVICE_CARD_GIG: 'LOHP - Clicked Catalog Service Card - Gig',
        LOHP_CLICKED_POPULAR_SERVICES_TAGS: 'LOHP - Clicked Popular Services Tags',
        LOHP_BRAND_MOTION_IS_TRIGGERED: 'LOHP - Brand Motion is Triggered',
        LOHP_CLICKED_VETTED_EXPERT_CARD: 'LOHP - Clicked Vetted Expert Card',
        LOHP_TESTIMONIALS_IS_SHOWN: 'LOHP - Testimonials is Shown',
        LOHP_BRAND_PAGE_VIEW: 'LOHP - Brand Page View',
        LOHP_CLICKED_PREMIUM_SERVICE: 'LOHP - Clicked Pro USPs',
    },

    BIANKA: {
        CLICKED_ON_CATALOG_SERVICE_BUTTON: 'clicked_on_catalog_service_button',
        CLICKED_ON_CATALOG_SERVICE_CTA: 'clicked_on_catalog_service_cta',
        CLICKED_ON_CATALOG_SERVICE_CARD: 'clicked_on_catalog_service_card',
        CLICKED_ON_CATALOG_SERVICE_SELLER: 'clicked_on_catalog_service_seller',
        CLICKED_ON_POPULAR_SERVICES_TAG: 'clicked_on_popular_services_tag',
        TOP_MOTION_IS_SHOWN: 'top_motion_is_shown',
        SOCIAL_PROOF_IS_SHOWN: 'social_proof_is_shown',
        EXPERTS_CAROUSEL_IS_SHOWN: 'experts_carousel_is_shown',
        EXPERTS_CAROUSEL_CARD_IS_SHOWN: 'experts_carousel_card_is_shown',
        CATALOG_SERVICES_IS_SHOWN: 'catalog_services_is_shown',
        POPULAR_SERVICES_TAGS_ARE_SHOWN: 'popular_services_tags_are_shown',
        CLICKED_ON_EXPERTS_CAROUSEL: 'clicked_on_experts_carousel',
        TESTIMONALS_IS_SHOWN: 'testimonals_is_shown',
        PRO_USPS_IS_SHOWN: 'pro_usps_is_shown',
        CLICKED_ON_PRO_USPS: 'clicked_on_pro_usps',
    },
} as const;
